<script>
import TWEEN from 'tween.js'
import Stories from '../data/stories'
import isMobile from '../utils/isMobile'

import AppNavbar from '@/components/AppNavbar'
import AppStory from '@/components/AppStory'

// bad
import BadStory1 from '@/components/BadStory1'
import BadStory2 from '@/components/BadStory2'
import BadStory3 from '@/components/BadStory3'
import BadStory4 from '@/components/BadStory4'
import BadStory5 from '@/components/BadStory5'
import BadStory6 from '@/components/BadStory6'
import BadStory7 from '@/components/BadStory7'
import BadStory8 from '@/components/BadStory8'
import BadStory9 from '@/components/BadStory9'

const assets = [
	require('../assets/main/story1.jpg'),
	require('../assets/main/story2.gif'),
	require('../assets/main/story3.jpg'),
	require('../assets/main/story4.gif'),
	require('../assets/main/story5.jpg'),
	require('../assets/main/story6.jpg'),
	require('../assets/main/story7.jpg'),
	require('../assets/main/story8.jpg'),
	require('../assets/main/story9.jpg'),
	require('../assets/bad/slot.png'),
	require('../assets/bad/story2.gif'),
	require('../assets/bad/story3.gif'),
	require('../assets/bad/story4.gif'),
	require('../assets/bad/story5.gif'),
	require('../assets/bad/story6.jpg'),
	require('../assets/bad/story7.gif'),
	require('../assets/bad/story8.jpg'),
	require('../assets/bad/story9.jpg'),
]


export default {
	name: 'Home',
	components: {
		AppNavbar,
		AppStory,
		BadStory1,
		BadStory2,
		BadStory3,
		BadStory4,
		BadStory5,
		BadStory6,
		BadStory7,
		BadStory8,
		BadStory9,
	},
	head: {
		meta: [
			{p: 'og:title', c: 'Афиша Zombie'},
			{p: 'og:description', c: 'Гид по "Ходячим мертвецам": все, чтобы вы могли выжить в мире зомби'},
			{p: 'og:image', c: '/static/share/all.jpg'},
			{p: 'og:site_name', c: 'Афиша Zombie'},
		]
	},
	data() {
		return {
			stories: Stories,
			width: 0,
			x: 0,
			y: 0,
			loaded: false,
			ready: false,
			badAlpha: {
				1: 0,
				2: 0,
				3: 0,
				4: 0,
				5: 0,
				6: 0,
				7: 0,
				8: 0,
				9: 0,
			}
		}
	},
	computed: {
		positionX() {
			return {transform: `translateX(${this.x}px)`}
		},
		positionY() {
			return {transform: `translateY(${this.y}px)`}
		}
	},
	async mounted() {

		for (let i = 0; i < assets.length; i++) {
			await this.preload(assets[i])
		}

		this.loaded = true

		this.ready = false
		this.x = window.innerWidth + 250
		this.y = window.innerHeight / 2

		let _this = this

		let startTweens = new TWEEN.Tween({a1: -2, a2: -3, a3: -10})
			.to({a1: 1, a2: 1, a3: 1}, 2000)
			.easing(TWEEN.Easing.Bounce.Out)
			.onUpdate(function () {
				_this.badAlpha[3] = this.a1
				_this.badAlpha[5] = this.a1
				_this.badAlpha[8] = this.a1

				_this.badAlpha[2] = this.a2
				_this.badAlpha[4] = this.a2
				_this.badAlpha[7] = this.a2

				_this.badAlpha[1] = this.a3
				_this.badAlpha[6] = this.a3
				_this.badAlpha[9] = this.a3
			})
			//.onComplete(() => sideTw1.start())

		let sideTween = new TWEEN.Tween({x: this.x})
			.delay(100)
			.easing(TWEEN.Easing.Bounce.Out)
			.to({x: window.innerWidth / 2}, 1500)
			.onUpdate(function () {
				_this.x = this.x
			})
			.onComplete(() => {
				this.ready = true
				ga('send', 'event', 'homepage', 'loaded')
			})

		if (!isMobile()) {
			startTweens.chain(sideTween)
			startTweens.start()
		} else {
			startTweens.onComplete(() => {
				this.ready = true
				ga('send', 'event', 'homepage', 'loaded')
			})
			startTweens.start()
		}

	},
	methods: {
		preload(url) {
			return new Promise((resolve) => {
				let img = new Image()
				img.onload = () => resolve()
				img.src = url
			})
		},
		startDrag() { this.dragging = true },
		stopDrag() {
			this.dragging = false
			let offset = this.x / window.innerWidth
			ga('send', 'event', 'home', 'slider', 'drag', offset)
		},
		onMove(e) {
			if (e.pageY - 80 > 5) this.y = e.pageY - 80
			if (this.dragging && this.ready) this.x = e.pageX
		},
		openHD() {
			ga('send', 'event', 'button', 'mobile', 'openHD')
			let _this = this
			let sideTween = new TWEEN.Tween({x: this.x})
				.easing(TWEEN.Easing.Bounce.Out)
				.to({x: 0}, 1500)
				.onUpdate(function () {
					_this.x = this.x
				})
				.onComplete(() => this.ready = true)
				.start()
		}
	}
}
</script>


<template>
<div class="home" @mousemove="onMove">

	<div class="layer good">
		<div class="inner">
		<app-navbar />
			<div class="content clearfix">
				<app-story
					:image="story.image"
					:size="story.size"
					:type="story.type"
					:link="story.link"
					:key="index"
					v-for="(story, index) in stories"
				>
					<h2 slot="title" v-html="story.title"></h2>
					<p slot="text" v-html="story.text"></p>
				</app-story>
			</div>
		</div>
	</div>

	<div class="layer bad" :style="{width: x + 'px'}">
		<div class="inner">
			<app-navbar />
			<div class="content clearfix">
				<bad-story-1 :alpha="badAlpha[1]" />
				<bad-story-2 :alpha="badAlpha[2]" />
				<bad-story-3 :alpha="badAlpha[3]" />
				<bad-story-4 :alpha="badAlpha[4]" />
				<bad-story-5 :alpha="badAlpha[5]" />
				<bad-story-6 :alpha="badAlpha[6]" />
				<bad-story-7 :alpha="badAlpha[7]" />
				<bad-story-8 :alpha="badAlpha[8]" />
				<bad-story-9 :alpha="badAlpha[9]" />
			</div>
		</div>
	</div>

	<div class="control" :style="positionX" @mousedown="startDrag" @mouseup="stopDrag">
		<div class="gradient"></div>
		<div class="line"></div>
		<div class="center" :style="positionY">
			<div class="triangle-left"></div>
			<div class="triangle-right"></div>
			<div class="text">Переходи на легальное<br>HD качество</div>
		</div>
	</div>

	<div class="control-mobile" :class="{visible: ready && x > 0}" @click="openHD">
		Нажми, чтобы перейти<br>на HD качество
	</div>

	<div class="preload" :class="{hide: loaded}"></div>

</div>
</template>


<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.home {
	width: 100%;
	height: 75vw;
	padding-top: 80px;
	overflow: hidden;
	position: relative;
}

.layer {
	width: 100vw;
	height: auto;
	position: absolute;
	user-select: none;
}

.good {
	width: 100%;
	height: auto;
	overflow: hidden;
	left: 0;
	top: 0;

	.inner {
		width: 100vw;
		height: auto;
		position: relative;
	}
}

.good {
	h2 {
		width: 90%;
		margin: 0 auto;
		font-size: 23px;
	}

	p {
		width: 90%;
		margin: 0 auto;
		padding-bottom: 5vh;
		font-size: 23px;
		font-family: @fontLava;
		font-weight: 600;
		transition: all 200ms ease;
	}

	.half h2 {
		color: @red;
		padding: 1vh 0;
		font-size: 15px;
	}

	.half p {
		font-size: 18px;
		font-weight: 400;
	}

	.center .mask {
		justify-content: center;
		text-align: center;
	}

	.center h2 {
		color: @red;
		font-size: 14px;
		padding: 1vh 0;
	}

}

.bad {
	width: 100%;
	height: auto;
	overflow: hidden;
	left: 0;
	top: 0;
	cursor: default;
	background: #090909;

	.inner {
		width: 100vw;
		height: auto;
		position: relative;
	}
}

.control {
	width: 40px;
	height: 75vw;
	position: absolute;
	margin-left: -20px;
	cursor: pointer;
	transition: opacity 300ms ease;

	.gradient {
		width: 200px;
		height: 100%;
		position: absolute;
		transform: translateX(-180px);
		background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
		pointer-events: none;
	}

	.line {
		width: 4px;
		height: 100%;
		background: @red;
		margin-left: 18px;
		position: absolute;
	}

	.center {
		width: 60px;
		height: 40px;
		position: absolute;
		margin-top: -20px;
		margin-left: -10px;
	}

	.text {
		width: 200px;
		position: absolute;
		color: #fff;
		text-align: right;
		margin-left: -210px;
		padding-right: 20px;
		text-shadow: 0 5px 30px #000;
	}

	.triangle-left {
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 10px 20px 10px 0;
		border-color: transparent @red transparent transparent;
		float: left;
		margin-top: 10px;
	}

	.triangle-right {
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 10px 0 10px 20px;
		border-color: transparent transparent transparent @red;
		float: left;
		margin-left: 20px;
		margin-top: 10px;
	}

}

.control-mobile {
	display: none;
}

.preload {
	width: 100%;
	height: 100%;
	position: absolute;
	background: #090909;
	pointer-events: all;
	opacity: 1;
	transition: opacity 300ms ease;
}

.preload.hide {
	opacity: 0;
	pointer-events: none;
}



@media only screen and (max-width: 1240px) {


.good .mask {
	h2 {
		font-size: 15px;
		padding-bottom: 1vh;
	}
	p {
		font-size: 15px;
		padding-bottom: 2vh;
	}
}

.bad .mask {
	h2 {
		font-size: 15px;
		padding-bottom: 1vh;
	}
	p {
		font-size: 15px;
		padding-bottom: 2vh;
	}
}



}




@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.home {
	width: 100%;
	height: 720vw;
	overflow: hidden;
	position: relative;
}

.bad {
	width: 100%;
	height: calc(720vw + 20px);
	overflow: hidden;
	left: 0;
	top: 0;
	cursor: default;
	background: #090909;
	-webkit-overflow-scrolling: touch;

	.inner {
		width: 100vw;
		height: auto;
		position: relative;
	}

	.story.small {
		width: 100vw;
		height: 80vw;
	}

	.story.big {
		width: 100vw;
		height: 80vw;
	}

}

.control {
	display: none;
}

.control-mobile {
	display: block;
	position: fixed;
	width: 100%;
	height: auto;
	padding: 20px 0;
	background: @red;
	bottom: 0;
	text-align: center;
	color: #fff;
	z-index: 100;
	transition: all 300ms ease;
	pointer-events: none;
	transform: translateY(100%);
}

.control-mobile.visible {
	pointer-events: all;
	transform: translateY(0);
}


}

</style>



// WEBPACK FOOTER //
// Home.vue?fe53e8a0